import { Message } from 'element-ui'
import store from '@ps/store'
import assets from '@ps/bridge/qc/assets'
import { isParticle } from '@ps/bridge/qc/base'
import { parseComponent } from '@ps/utils/game'

export default {
  async addParticle({ dispatch }, { id, resSource, from, parentNode }) {
    const res = await store.dispatch(
      'workspace/resourceManager/readComponent',
      { id, resSource, from },
    )
    res.data.type = 2
    if (!res.data.files) return
    const _res = parseComponent(res)
    if (_res.errorMsg) {
      Message({
        message: _res.errorMsg,
        type: 'error',
        duration: 3 * 1000,
        showClose: true,
      })
      return
    }
    const { node } = await store.dispatch(
      'workspace/game/prefab/addNewPrefab',
      {
        res: {
          name: _res.prefabName,
          json: _res.json,
          meta: _res.meta,
          projectKey: store.state.workspace.pid,
          files: _res.files,
          uuid2url: assets.uuid2UrlConf,
          type: _res.type,
          animationType: _res.animationType, // 用于识别龙骨类型的图集
        },
        parentNode,
      },
    )
    const setParticleNode = (node, arr) => {
      if (isParticle(node)) {
        node.pivotX = 0.5
        node.pivotY = 0.5
        // 如果不设置该值，复用位置会导致粒子不正常
        node.minAnchor.x =
          node.minAnchor.y =
          node.maxAnchor.x =
          node.maxAnchor.y =
            0.5
        store.commit('workspace/game/setWidth', { value: 200, node })
        store.commit('workspace/game/setHeight', { value: 200, node })
        arr.push(node)
      }
      ;(node.children || []).forEach((cNode) => {
        setParticleNode(cNode, arr)
      })
    }
    const extra = res.data.extra || []
    const nameReg = /.*\/?.*_(.*)((\.png)|(\.jpg))$/
    const images = extra.filter((item) => nameReg.test(item.name))
    const imageMap = images.reduce((memo, cur) => {
      const matched = cur.name.match(nameReg)
      if (matched) {
        memo[matched[1]] = cur.url
      }
      return memo
    }, {})
    const particleNode = []
    setParticleNode(node, particleNode)
    particleNode.forEach((node) => {
      store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
        originalResource: imageMap[node.texture.atlas.uuid],
        resource: imageMap[node.texture.atlas.uuid],
        node,
      })
    })
    return await node
  },
}
